import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowShapeDiamond({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M1.378 8.823c-.504-.415-.504-1.231 0-1.646l6.039-4.964a.91.91 0 0 1 1.169 0l6.038 4.964c.505.415.505 1.231 0 1.646l-6.038 4.964a.91.91 0 0 1-1.17 0L1.379 8.823z"/>
        </svg>
    );
}

export default IconFlowShapeDiamond;
